import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Image } from "antd";
import "../App.css";

const imgItems = [
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/place.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/place_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/Hollow1.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/Hollow1_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/Hollow2.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/Hollow2_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/Oct_Perspective.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/Oct_Perspective_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/Dale.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/Dale_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/Time2.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/Time2_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/SP_Stanford.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/SP_Stanford_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/Phantom.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/Phantom_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/Artwork.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/Artwork_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/Station.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/Station_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/SP_Beach.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/SP_Beach_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/SP_Tree.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/SP_Tree_blur.jpg`,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/jpg/hall.jpg`,
    placeholderSrc: `${process.env.PUBLIC_URL}/images/jpg/hall_blur.jpg`,
  },
];
const imageRenderDiv = (originalNode, info) => {
  return (
    <>
      {info.image.url === imgItems[5].src ||
      info.image.url === imgItems[7].src ||
      info.image.url === imgItems[9].src ? (
        <div className="wh100 preRoot">
          <div className="preLeft colCenter">
            <Image
              src={info.image.url}
              className="preImg"
              preview={false}
              placeholder={
                <Image
                  preview={false}
                  src={
                    imgItems.filter((item) => item.src === info.image.url)[0]
                      .placeholderSrc
                  }
                  className="preImg"
                />
              }
            />
          </div>
          <div className="preRight colCenter">
            <div className="preTxtBox">
              <div className="preTxt">
                {info.image.url === imgItems[5].src ? (
                  <div className="preTxtMain">Time of the Day</div>
                ) : info.image.url === imgItems[7].src ? (
                  <div className="preTxtMain">
                    Background Painting- Phantom 309
                  </div>
                ) : (
                  <div className="preTxtMain">
                    Background Painting Afters Store
                  </div>
                )}
                <div className="preTxtLink fUnder">
                  {info.image.url === imgItems[5].src ? (
                    <Link to="/Time" className="preLink">
                      Go to Page Time of the Day
                    </Link>
                  ) : info.image.url === imgItems[7].src ? (
                    <Link to="/Phantom" className="preLink">
                      Go to Page Phantom 309
                    </Link>
                  ) : (
                    <Link to="/Afters" className="preLink">
                      Go to Page Afters
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="wh100 preRoot colCenter">
          <Image
            src={info.image.url}
            className="preImg"
            preview={false}
            placeholder={
              <Image
                preview={false}
                src={
                  imgItems.filter((item) => item.src === info.image.url)[0]
                    .placeholderSrc
                }
                className="preImg"
              />
            }
          />
        </div>
      )}
    </>
  );
};
export default class Illustration extends Component {
  state = { current: 0 };
  setCurrent = (current) => {
    this.setState({ current });
  };
  render() {
    const { current } = this.state;
    return (
      <>
        <Row>
          <Col span={1}></Col>
          <Col span={22}>
            <Row>
              <Col span={24} className="projectILLTitle">
                Illustration
              </Col>
              <Col span={24} className="projectSubTitle">
                Explorations of styles, design, storytelling, and composition.
              </Col>
              <Col span={24} className="rH50"></Col>
            </Row>
            <Row>
              <Col xs={0} sm={1} md={1} lg={1} xl={1}></Col>
              <Col
                xs={24}
                sm={22}
                md={22}
                lg={22}
                xl={22}
                className="galleryContent"
              >
                <Row gutter={[8, 8]} align="stretch">
                  <Col flex={"100%"}>
                    <Image.PreviewGroup
                      items={imgItems}
                      preview={{
                        current,
                        destroyOnClose: true,
                        countRender: () => null,
                        imageRender: imageRenderDiv,
                        toolbarRender: () => null,
                        onChange: (current) => {
                          this.setState({ current });
                        },
                      }}
                    >
                      <Image
                        src={imgItems[0].src}
                        placeholder={
                          <Image
                            preview={false}
                            src={imgItems[0].placeholderSrc}
                            className="wh100"
                          />
                        }
                        alt="Illustration 1 Image"
                        className="w100"
                        loading="lazy"
                        preview={{
                          visible: false,
                          mask: <div></div>,
                        }}
                        onClick={() => this.setCurrent(0)}
                      />
                    </Image.PreviewGroup>
                  </Col>
                  <Col
                    xs={{ flex: "100%" }}
                    sm={{ flex: "50%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "50%" }}
                    xl={{ flex: "50%" }}
                  >
                    <Image.PreviewGroup
                      items={imgItems}
                      preview={{
                        current,
                        destroyOnClose: true,
                        countRender: () => null,
                        imageRender: imageRenderDiv,
                        toolbarRender: () => null,
                        onChange: (current) => {
                          this.setState({ current });
                        },
                      }}
                    >
                      <Image
                        src={imgItems[1].src}
                        alt="Illustration 2 Image"
                        className="wh100"
                        loading="lazy"
                        preview={{
                          visible: false,
                          mask: <div></div>,
                        }}
                        placeholder={
                          <Image
                            preview={false}
                            src={imgItems[1].placeholderSrc}
                            className="wh100"
                          />
                        }
                        onClick={() => this.setCurrent(1)}
                      />
                    </Image.PreviewGroup>
                  </Col>
                  <Col
                    xs={{ flex: "100%" }}
                    sm={{ flex: "50%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "50%" }}
                    xl={{ flex: "50%" }}
                  >
                    <Image.PreviewGroup
                      items={imgItems}
                      preview={{
                        current,
                        destroyOnClose: true,
                        countRender: () => null,
                        imageRender: imageRenderDiv,
                        toolbarRender: () => null,
                        onChange: (current) => {
                          this.setState({ current });
                        },
                      }}
                    >
                      <Image
                        src={imgItems[2].src}
                        alt="Illustration 3 Image"
                        className="wh100"
                        loading="lazy"
                        placeholder={
                          <Image
                            preview={false}
                            src={imgItems[2].placeholderSrc}
                            className="wh100"
                          />
                        }
                        preview={{
                          visible: false,
                          mask: <div></div>,
                        }}
                        onClick={() => this.setCurrent(2)}
                      />
                    </Image.PreviewGroup>
                  </Col>
                  <Col
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "100%" }}
                    lg={{ flex: "51%" }}
                    xl={{ flex: "51%" }}
                  >
                    <Row gutter={[8, 8]} align="stretch">
                      <Col
                        xs={{ flex: "100%" }}
                        sm={{ flex: "59%" }}
                        md={{ flex: "59%" }}
                        lg={{ flex: "59%" }}
                        xl={{ flex: "59%" }}
                      >
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[3].src}
                            alt="Illustration 4 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[3].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(3)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                      <Col
                        xs={{ flex: "100%" }}
                        sm={{ flex: "41%" }}
                        md={{ flex: "41%" }}
                        lg={{ flex: "41%" }}
                        xl={{ flex: "41%" }}
                      >
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[4].src}
                            alt="Illustration 5 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[4].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(4)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                      <Col>
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[5].src}
                            alt="Illustration 6 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[5].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(5)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "100%" }}
                    lg={{ flex: "49%" }}
                    xl={{ flex: "49%" }}
                  >
                    <Row gutter={[8, 8]} align="stretch">
                      <Col>
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[6].src}
                            alt="Illustration 7 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[6].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(6)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                      <Col
                        xs={{ flex: "100%" }}
                        sm={{ flex: "71%" }}
                        md={{ flex: "71%" }}
                        lg={{ flex: "71%" }}
                        xl={{ flex: "71%" }}
                      >
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[7].src}
                            alt="Illustration 8 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[7].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(7)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                      <Col
                        xs={{ flex: "100%" }}
                        sm={{ flex: "29%" }}
                        md={{ flex: "29%" }}
                        lg={{ flex: "29%" }}
                        xl={{ flex: "29%" }}
                      >
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[8].src}
                            alt="Illustration 9 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[8].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(8)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "100%" }}
                    lg={{ flex: "46%" }}
                    xl={{ flex: "46%" }}
                  >
                    <Row gutter={[8, 8]} align="stretch">
                      <Col>
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[9].src}
                            alt="Illustration 10 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[9].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(9)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                      <Col
                        xs={{ flex: "100%" }}
                        sm={{ flex: "35%" }}
                        md={{ flex: "35%" }}
                        lg={{ flex: "35%" }}
                        xl={{ flex: "35%" }}
                      >
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[10].src}
                            alt="Illustration 11 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[10].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(10)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                      <Col
                        xs={{ flex: "100%" }}
                        sm={{ flex: "65%" }}
                        md={{ flex: "65%" }}
                        lg={{ flex: "65%" }}
                        xl={{ flex: "65%" }}
                      >
                        <Image.PreviewGroup
                          items={imgItems}
                          preview={{
                            current,
                            destroyOnClose: true,
                            countRender: () => null,
                            imageRender: imageRenderDiv,
                            toolbarRender: () => null,
                            onChange: (current) => {
                              this.setState({ current });
                            },
                          }}
                        >
                          <Image
                            src={imgItems[11].src}
                            alt="Illustration 12 Image"
                            className="wh100"
                            loading="lazy"
                            placeholder={
                              <Image
                                preview={false}
                                src={imgItems[11].placeholderSrc}
                                className="wh100"
                              />
                            }
                            preview={{
                              visible: false,
                              mask: <div></div>,
                            }}
                            onClick={() => this.setCurrent(11)}
                          />
                        </Image.PreviewGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "100%" }}
                    lg={{ flex: "54%" }}
                    xl={{ flex: "54%" }}
                  >
                    <Image.PreviewGroup
                      items={imgItems}
                      preview={{
                        current,
                        destroyOnClose: true,
                        countRender: () => null,
                        imageRender: imageRenderDiv,
                        toolbarRender: () => null,
                        onChange: (current) => {
                          this.setState({ current });
                        },
                      }}
                    >
                      <Image
                        src={imgItems[12].src}
                        alt="Illustration 13 Image"
                        className="wh100"
                        loading="lazy"
                        placeholder={
                          <Image
                            preview={false}
                            src={imgItems[12].placeholderSrc}
                            className="wh100"
                          />
                        }
                        preview={{
                          visible: false,
                          mask: <div></div>,
                        }}
                        onClick={() => this.setCurrent(12)}
                      />
                    </Image.PreviewGroup>
                  </Col>
                </Row>
                {/* <Row gutter={[8, 8]}>
                  <Col span={24}>
                    
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    
                  </Col>
                  <Col span={24}>
                    <Row gutter={[8, 8]}>
                      <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                        <Row gutter={[8, 8]}>
                          <Col xs={24} sm={15} md={15} lg={15} xl={15}>
                            
                          </Col>
                          <Col xs={24} sm={9} md={9} lg={9} xl={9}>
                            
                          </Col>
                          <Col span={24}>
                            
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} sm={24} md={11} lg={11} xl={11}>
                        <Row gutter={[8, 8]}>
                          <Col span={24}>
                            
                          </Col>
                          <Col xs={24} sm={17} md={17} lg={17} xl={17}>
                            
                          </Col>
                          <Col xs={24} sm={7} md={7} lg={7} xl={7}>
                            
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[8, 8]}>
                      <Col xs={24} sm={24} md={11} lg={11} xl={11}>
                        
                      </Col>
                      <Col xs={24} sm={9} md={5} lg={5} xl={5}>
                        
                      </Col>
                      <Col xs={24} sm={15} md={8} lg={8} xl={8}>
                        
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
              </Col>
              <Col xs={0} sm={1} md={1} lg={1} xl={1}></Col>
            </Row>
          </Col>
          <Col span={1}></Col>
        </Row>
        <Row>
          <Col className="rH100"></Col>
        </Row>
      </>
    );
  }
}
